<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4" id="button_user">
      <h1 class="h3 mb-0 text-gray-800 d-inline-block">Contract</h1>
    </div>
    <table-skeleton v-show="is_loading"/>
    <div class="row" v-show="!is_loading">
      <div class="col-12">
        <custom-table :arr="arr" :total_page="total_page" url_detail="/contract/detail" url_delete="/contract" :arr_id="arr_id" :arr_header="arr_header" @on_refresh_start="on_refresh_start" @on_refresh_end="on_refresh_end"/>
      </div>
    </div>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import table_skeleton from '@/layout/table_skeleton'

export default {
  components:{
    'custom-table': custom_table,
    'table-skeleton': table_skeleton,
  },
  data(){
    return{
      arr:[],
      arr_id: ['1'],
      arr_header: ['image','publish','type'],
      total_page: 1,
      is_loading: true,
    }
  },
  async created(){
    await this.get_data()
    this.is_loading = false
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/contract?api_type=web-admin')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr = response_data.arr
          this.arr_header = response_data.arr_header
          this.arr_id = response_data.arr_id
          this.total_page = response_data.total_page
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
